import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNewsList, updateNewsStatus, createNews } from '../redux/actions/newsActions'; // Import updateNewsStatus

const News = () => {
  const dispatch = useDispatch();

  const { adminData } = useSelector((state) => state.admin);
  const { newsCount, activeNews, inactiveNews, loading } = useSelector((state) => state.news);

  const [currentTab, setCurrentTab] = useState('active');
  const [showCreatePopup, setShowCreatePopup] = useState(false); // State to control popup visibility
  const [newsData, setNewsData] = useState({
    title: '',
    newsContent: '',
    refLinks: '',
    availableTill: '',
    thumbnail: '',
  });

  useEffect(() => {
    if (adminData) {
      dispatch(fetchNewsList(adminData));
    }
  }, [dispatch, adminData]);

  if (loading) {
    return <p>Loading...</p>;
  }

  // if (error) {
  //   return <p>Error: {error}</p>;
  // }

  const handleTabSwitch = (tab) => {
    setCurrentTab(tab);
  };

  // const handleToggle = (news) => {
  //   const newsID = news.SK.split('#')[1]; // Extract the ID from SK
  //   const updatedStatus = news.status === 'active' ? 'inactive' : 'active'; // Toggle the status

  //   const payload = JSON.stringify({
  //     newsID: newsID,
  //     title: news.title,
  //     newsContent: news.newsContent,
  //     refLinks: news.refLinks,
  //     availableTill: news.availableTill,
  //     status: updatedStatus, // Send the updated status
  //     thumbnail: news.thumbnail || "", // Preserve existing thumbnail
  //   });

  //   dispatch(updateNewsStatus(adminData, payload)); // Dispatch the action to update the news status
  // };


  const handleToggle = (news) => {
    const newsID = news.SK.split('#')[1]; // Extract the ID from SK
    const updatedStatus = news.status === 'active' ? 'inactive' : 'active'; // Toggle the status
  
    const payload = JSON.stringify({
      newsID: newsID,
      title: news.title,
      newsContent: news.newsContent,
      refLinks: news.refLinks,
      availableTill: news.availableTill,
      status: updatedStatus, // Send the updated status
      thumbnail: news.thumbnail || "", // Preserve existing thumbnail
    });
  
    dispatch(updateNewsStatus(adminData, payload))
      .then(() => {
        // Optimistically update the state in the Redux store
        dispatch(fetchNewsList(adminData)); // Refresh the news list after toggling status
      });
  };
  
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file); // Convert image to Base64
    reader.onloadend = () => {
      setNewsData({ ...newsData, thumbnail: reader.result }); // Set thumbnail as Base64
    };
  };

  const isCreateDisabled = !newsData.thumbnail; // Disable if no image, title, or content

  const handleCreateNews = () => {
    const base64String = newsData.thumbnail.split(',')[1];
    console.log(base64String);
    if (adminData) {
      const payload = {
        id: adminData.id,
        title: newsData.title,
        newsContent: newsData.newsContent,
        refLinks: newsData.refLinks || "", // Send empty string if not provided
        availableTill: newsData.availableTill || "",
        thumbnail: base64String, // Base64 thumbnail
      };
      dispatch(createNews(adminData, payload)); // Dispatch the createNews action
      setShowCreatePopup(false); // Close the popup after creation
    }
  };

  const filteredNews = currentTab === 'active' ? activeNews : inactiveNews;

  return (
    <div className="container mx-auto mt-4 px-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Total News: {newsCount}</h1>
        <div className="flex items-center">
          <button
            className={`mr-4 px-3 py-2 ${currentTab === 'active' ? 'font-bold text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`}
            onClick={() => handleTabSwitch('active')}
          >
            Active
          </button>
          <button
            className={`mr-4 px-3 py-2 ${currentTab === 'inactive' ? 'font-bold text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`}
            onClick={() => handleTabSwitch('inactive')}
          >
            Inactive
          </button>
          <button
            className="px-4 py-2 bg-blue-600 text-white rounded-md"
            onClick={() => setShowCreatePopup(true)} // Open the create news popup
          >
            Create
          </button>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold mb-4">{currentTab.charAt(0).toUpperCase() + currentTab.slice(1)} News</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.isArray(filteredNews) && filteredNews.length > 0 ? (
            filteredNews.map((news) => (
              <div key={news.SK} className="p-4 bg-white shadow-md rounded-md">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-500 text-sm">{new Date(news.createdAt).toDateString()}</span>
                </div>
                <h3 className="font-bold text-lg mb-2">{news.title}</h3>
                <div className="w-full h-48 mb-2">
                  <img
                    src={news.thumbnail}
                    alt={news.title}
                    className="w-full h-full object-cover rounded-md"
                  />
                </div>
                <div className="text-sm mb-4">{news.newsContent}</div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-500">Available till {news.availableTill}</span>
                  <div className="flex items-center">
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={news.status === 'active'}
                        onChange={() => handleToggle(news)} // Trigger the toggle action
                      />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                    </label>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No {currentTab} news available.</p>
          )}
        </div>
      </div>

      {/* Popup for creating news */}
      {showCreatePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-3/4 md:w-1/2 lg:w-1/3 relative">
            <button
              className="absolute top-4 right-4 text-gray-600"
              onClick={() => setShowCreatePopup(false)} // Close popup
            >
              X
            </button>

            {/* Image Upload Placeholder */}
            <div className="text-center mb-4">
              <div className="w-32 h-32 bg-gray-200 rounded-md mx-auto cursor-pointer relative">
                <input
                  type="file"
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  onChange={handleImageUpload} // Handle image upload
                />
                {newsData.thumbnail ? (
                  <img src={newsData.thumbnail} alt="News" className="w-full h-full object-cover rounded-md" />
                ) : (
                  <span className="text-gray-600">Choose Image</span>
                )}
              </div>
            </div>

            {/* Form Fields */}
            <div className="mb-4">
              <input
                type="text"
                placeholder="Title"
                className="w-full px-3 py-2 border rounded-md"
                value={newsData.title}
                onChange={(e) => setNewsData({ ...newsData, title: e.target.value })}
              />
            </div>
            <div className="mb-4">
              <textarea
                placeholder="News Content"
                className="w-full px-3 py-2 border rounded-md"
                value={newsData.newsContent}
                onChange={(e) => setNewsData({ ...newsData, newsContent: e.target.value })}
              />
            </div>
            <div className="mb-4">
              <input
                type="text"
                placeholder="Reference Links"
                className="w-full px-3 py-2 border rounded-md"
                value={newsData.refLinks}
                onChange={(e) => setNewsData({ ...newsData, refLinks: e.target.value })}
              />
            </div>
            <div className="mb-4">
              <input
                type="date"
                className="w-full px-3 py-2 border rounded-md"
                value={newsData.availableTill}
                onChange={(e) => setNewsData({ ...newsData, availableTill: e.target.value })}
              />
            </div>

            {/* Create Button */}
            <div className="text-center">
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md"
                onClick={handleCreateNews}
                disabled={isCreateDisabled} // Disable if no image or other fields are empty
              >
                Create
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default News;
